import React, { useState } from 'react';
import { DateRangePicker } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import './DateTimeRangePicker.scss';

/** @param {import('rsuite').DateRangePickerProps & {hasError: boolean}} param0 */
const DateTimeRangePicker = ({
    hasError,
    character,
    value: controlledValue,
    ...props
}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const { DateTimeFormat: dateTimeFormat } = JSON.parse(sessionStorage.getItem('jwtUserInfo') || '{}');
    
    let defaultDateTimeFormat = dateTimeFormat ? `${dateTimeFormat.LongDateFormat} ${dateTimeFormat.TimeFormat}` : 'yyyy-MM-dd HH:mm aa';
    const isMeridiem = !defaultDateTimeFormat.includes('aa') && defaultDateTimeFormat.includes('a');
    if (isMeridiem) {
        defaultDateTimeFormat = defaultDateTimeFormat.replace('a', 'aa');
    }

    const calendarIcon = React.forwardRef((iconProps, ref) => {
        return (
            <FontAwesomeIcon
                className="date-time-picker-caret-icon"
                icon={faCalendarDays} 
                {...iconProps} 
                ref={ref}
            />)
    });

    const chevronIcon = isMenuOpen 
        ? (<FontAwesomeIcon icon={faChevronUp} />)
        : (<FontAwesomeIcon icon={faChevronDown} />);

    return (
        <div className={`core--datetime-range-picker ${hasError ? 'core--datetime-range-picker-error' : ''}`}>
            <DateRangePicker
                menuClassName="core--datetime-range-picker-menu"
                character={character || ' - '}
                format={defaultDateTimeFormat}
                caretAs={calendarIcon}
                showHeader={false}
                showMeridiem={isMeridiem}
                onOpen={() => setIsMenuOpen(true)}
                onExit={() => setIsMenuOpen(false)}
                value={controlledValue?.filter((date) => date !== null)}
                {...props}
            />
            <div className="date-time-range-picker-chevron-icon-wrapper">
                {chevronIcon}
            </div>
        </div>
    );
};

export default DateTimeRangePicker;
